import React from 'react';
import './Section3.css'

const Section3 = () => {
    return (
        <div>
            <div className="pt-24">
            <div className="main-anather3 ">
                <div className="anather-info">
                    <h1 className='py-2'>THE LATEST STYLES & TRENDS</h1>
                    <p className='py-2'>
                    _From shirts to formal wear we customize everything imaginable!</p>
                </div>
                <div className="anather-btn">
                    <button className='btn '>VIEW OUR CUSTOM COLLECTIONS</button>
                </div>
            </div>
            </div>
        </div>
    );
};

export default Section3;